export default {
  partner:
    'Imposta la tua commissione di elaborazione Stripe o conferma un margine dello 0%. Fino ad allora i tuoi ristoranti su Stripe non possono andare online.',
  partner_live_one:
    'Imposta la tua commissione di elaborazione Stripe o conferma un margine dello 0%. Fino ad allora i tuoi ristoranti su Stripe non possono andare online e il tuo ristorante attivo non riceve pagamenti online.',
  partner_live_other:
    'Imposta la tua commissione di elaborazione Stripe o conferma un margine dello 0%. Fino ad allora i tuoi ristoranti su Stripe non possono andare online e i tuoi {{count}} ristoranti attivi non ricevono pagamenti online.',
  restaurant:
    'I pagamenti online sono in pausa finché il tuo partner non imposta la commissione di elaborazione. I pagamenti in contanti funzionano ancora.',
  cta: 'Imposta commissione',
};
